import React, { useContext } from "react";
import { getValue, formatMonto } from "../../utils";
import { AuthContext } from "../../context/AuthContext";
import { getConceptosKeys, getSumConcepto, isAirConditioner } from "../../utils/conceptos";
import { ConceptosUbicacionesContext } from "../../context/ConceptosUbicacionesContext";
import useProyecto from "../../hooks/useProyecto";

const ConceptoMedicionForm = ({
  concepto,
  idProyecto,
  idContrato,
  handleCancel,
  handleCallback,
  idEstimacionVersion,
}) => {
  const { permiso } = useProyecto();
  const { user } = useContext(AuthContext);
  const { saveConceptoUbicacion, setPropertyConceptosUbicacion } = useContext(
    ConceptosUbicacionesContext
  );

  const handleSave = () => {
    if (!isNaN(parseInt(concepto.idConceptoMedicion))) {
      if (concepto.idUsuario !== user.idUsuario) {
        delete concepto.idConceptoMedicion;
        delete concepto.idUsuario;
      }
    }
    concepto.idEstimacionVersion = idEstimacionVersion;
    const conceptoData = { ...concepto };
    delete conceptoData.Usuario;
    delete conceptoData.Concepto;
    delete conceptoData.ubicaciones;
    delete conceptoData.estimaciones;
    delete conceptoData.ConceptoMedicions;
    saveConceptoUbicacion(idProyecto, idContrato, conceptoData, handleCallback);
  };

  const renderContratistaCampos = () => {
    const keys = getConceptosKeys(concepto);
    return (
      <>
        {permiso !== "contratista" ? (
          <>
            {keys.map((key) => {
              const conceptoMedicion = concepto.ConceptoMedicions.find(
                (cm) => cm.Usuario.defaultType === 6
              ) || {};
              let value = "";
              if (key === "semip") {
                const a = parseFloat(conceptoMedicion.ancho);
                const b = parseFloat(conceptoMedicion.alto);
                value = !isNaN(a) && !isNaN(b) ? a + b : "";
              } else {
                value = conceptoMedicion[key] ?? "";
              }
              return (
                <td className="border" key={key} id={`contratista-readonly-${key}`}>
                  {value}
                </td>
              );
            })}
            <td id="contratista-readonly-total">
              {formatMonto(
                getSumConcepto(
                  concepto.ConceptoMedicions.find(
                    (cm) => cm.Usuario.defaultType === 6
                  ) || {}
                )
              )}
            </td>
          </>
        ) : (
          keys.map((key) => {
            let value = "";
            if (key === "semip") {
              const a = parseFloat(concepto.ancho);
              const b = parseFloat(concepto.alto);
              value = !isNaN(a) && !isNaN(b) ? a + b : "";
            } else {
              value = concepto[key] ?? "";
            }
            return (
              <td className="border" key={key} id={`contratista-input-${key}`}>
                <input
                  type="text"
                  className="form-control"
                  id={`input-contratista-${key}`}
                  value={value}
                  onChange={(e) =>
                    setPropertyConceptosUbicacion(
                      concepto.idConceptoUbicacion,
                      key,
                      e.target.value
                    )
                  }
                  disabled={key === "semip"}
                  readOnly={key === "semip"}
                />
              </td>
            );
          })
        )}
      </>
    );
  };

  const renderSupervisorCampos = () => {
    const keys = getConceptosKeys(concepto);
    return (
      <>
        {permiso !== "supervisor" ? (
          <>
            {keys.map((key) => {
              const conceptoMedicion = concepto.ConceptoMedicions.find(
                (cm) => cm.Usuario.defaultType === 3
              ) || {};
              let value = "";
              if (key === "semip") {
                const a = parseFloat(conceptoMedicion.ancho);
                const b = parseFloat(conceptoMedicion.alto);
                value = !isNaN(a) && !isNaN(b) ? a + b : "";
              } else {
                value = conceptoMedicion[key] ?? "";
              }
              return (
                <td className="border" key={key} id={`supervisor-readonly-${key}`}>
                  {value}
                </td>
              );
            })}
            <td id="supervisor-readonly-total">
              {formatMonto(
                getSumConcepto(
                  concepto.ConceptoMedicions.find(
                    (cm) => cm.Usuario.defaultType === 3
                  ) || {}
                )
              )}
            </td>
          </>
        ) : (
          keys.map((key) => {
            let value = "";
            if (key === "semip") {
              const a = parseFloat(concepto.ancho);
              const b = parseFloat(concepto.alto);
              value = !isNaN(a) && !isNaN(b) ? a + b : "";
            } else {
              value = concepto[key] ?? "";
            }
            return (
              <td className="border" key={key} id={`supervisor-input-${key}`}>
                <input
                  type="text"
                  className="form-control"
                  id={`input-supervisor-${key}`}
                  value={value}
                  onChange={(e) =>
                    setPropertyConceptosUbicacion(
                      concepto.idConceptoUbicacion,
                      key,
                      e.target.value
                    )
                  }
                  disabled={key === "semip"}
                  readOnly={key === "semip"}
                />
              </td>
            );
          })
        )}
      </>
    );
  };

  const renderObrasCampos = () => {
    const keys = getConceptosKeys(concepto);
    return (
      <>
        {permiso !== "obras" ? (
          <>
            {keys.map((key) => {
              const conceptoMedicion = concepto.ConceptoMedicions.find(
                (cm) => cm.Usuario.defaultType === 5
              ) || {};
              let value = "";
              if (key === "semip") {
                const a = parseFloat(conceptoMedicion.ancho);
                const b = parseFloat(conceptoMedicion.alto);
                value = !isNaN(a) && !isNaN(b) ? a + b : "";
              } else {
                value = conceptoMedicion[key] ?? "";
              }
              return (
                <td className="border" key={key} id={`obras-readonly-${key}`}>
                  {value}
                </td>
              );
            })}
            <td id="obras-readonly-total">
              {formatMonto(
                getSumConcepto(
                  concepto.ConceptoMedicions.find(
                    (cm) => cm.Usuario.defaultType === 5
                  ) || {}
                )
              )}
            </td>
          </>
        ) : (
          keys.map((key) => {
            let value = "";
            if (key === "semip") {
              const a = parseFloat(concepto.ancho);
              const b = parseFloat(concepto.alto);
              value = !isNaN(a) && !isNaN(b) ? a + b : "";
            } else {
              value = concepto[key] ?? "";
            }
            return (
              <td className="border" key={key} id={`obras-input-${key}`}>
                <input
                  type="text"
                  className="form-control"
                  id={`input-obras-${key}`}
                  value={value}
                  onChange={(e) =>
                    setPropertyConceptosUbicacion(
                      concepto.idConceptoUbicacion,
                      key,
                      e.target.value
                    )
                  }
                  disabled={key === "semip"}
                  readOnly={key === "semip"}
                />
              </td>
            );
          })
        )}
      </>
    );
  };

  const renderTotal = () => {
    const total = getSumConcepto(concepto);
    return formatMonto(total);
  };

  const isAC = isAirConditioner(concepto);
  const ubicacionFields = isAC ? ["eje"] : ["eje", "tramo", "tipo", "nivel"];

  return (
    <>
      <tr>
        {ubicacionFields.map((key) => (
          <td className="border" key={key} id={`ubicacion-${key}`}>
            <input
              type="text"
              className="form-control"
              id={`input-ubicacion-${key}`}
              value={getValue(concepto, key)}
              onChange={(e) =>
                setPropertyConceptosUbicacion(
                  concepto.idConceptoUbicacion,
                  key,
                  e.target.value
                )
              }
            />
          </td>
        ))}
        {renderContratistaCampos()}
        {renderSupervisorCampos()}
        <td className="border" id="total-column">{renderTotal()}</td>
        {renderObrasCampos()}
        <td className="border" id="actions-column">
          <button
            onClick={handleSave}
            className="btn btn-sm btn-outline-dark me-2"
            id="btn-save"
          >
            <i className="fa fa-save" />
          </button>
          <button
            onClick={() => handleCancel(concepto.idConceptoUbicacion)}
            className="btn btn-sm btn-outline-danger"
            id="btn-cancel"
          >
            <i className="fa fa-times" />
          </button>
        </td>
      </tr>
    </>
  );
};

export default ConceptoMedicionForm;
